import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

function SModal({
  show,
  title,
  children,
  footer,
  onClose,
  modalClassName = '',
}) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName={modalClassName}
    >
      {title && (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{children}</Modal.Body>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
}

SModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.oneOf([PropTypes.element, PropTypes.string]),
  footer: PropTypes.oneOf([
    PropTypes.element,
    PropTypes.string,
    PropTypes.object,
  ]),
  modalClassName: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.element,
};

export default SModal;
